const initialState = {
    specialEvents: []
};

const specialEventsReducer = (state = initialState, action) => {
    switch(action.type) {
        case 'SPECIAL_EVENTS':
            return { ...state, specialEvents: action.payload };
        default:
            return state;
    }
};

export default specialEventsReducer;